const userAgent = navigator.userAgent || navigator.vendor || window.opera;

// 获取操作系统
export function getOS() {
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }
  if (/android/i.test(userAgent)) {
    return 'Android';
  }
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }
  if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent)) {
    return 'MacOS';
  }
  if (/Win32|Win64|Windows|WOW64/.test(userAgent)) {
    return 'Windows';
  }
  if (/Linux/.test(userAgent)) {
    return 'Linux';
  }
  return 'Unknown';
}

// 获取浏览器类型
export function getBrowserType() {
  if (userAgent.indexOf('Firefox') > -1) {
    return 'Firefox';
  } else if (userAgent.indexOf('Edg') > -1) {
    return 'Microsoft Edge';
  } else if (userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Safari') > -1) {
    return 'Chrome';
  } else if (userAgent.indexOf('Safari') > -1) {
    return 'Safari';
  } else if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) {
    return 'Opera';
  } else if (userAgent.indexOf('Trident') > -1 || userAgent.indexOf('MSIE') > -1) {
    return 'Internet Explorer';
  }
  return 'Unknown';
}

// 获取浏览器版本
export function getBrowserVersion() {
  if (/firefox\/(\d+\.\d+)/i.test(userAgent)) {
    return `Firefox ${RegExp.$1}`;
  }
  if (/edg\/(\d+\.\d+)/i.test(userAgent)) {
    return `Microsoft Edge ${RegExp.$1}`;
  }
  if (/chrome\/(\d+\.\d+)/i.test(userAgent) && !/edg\//i.test(userAgent)) {
    return `Chrome ${RegExp.$1}`;
  }
  if (/safari\/(\d+\.\d+)/i.test(userAgent) && !/chrome|crios/i.test(userAgent)) {
    if (/version\/(\d+\.\d+)/i.test(userAgent)) {
      return `Safari ${RegExp.$1}`;
    }
    return 'Safari (version unknown)';
  }
  if (/opr\/(\d+\.\d+)/i.test(userAgent)) {
    return `Opera ${RegExp.$1}`;
  }
  if (/trident\/7.0.*rv:(\d+\.\d+)/i.test(userAgent)) {
    return `Internet Explorer ${RegExp.$1}`;
  }
  return 'Unknown Browser or Version';
}

// 获取操作系统版本
export function getOSVersion() {
  if (/windows nt 10.0/i.test(userAgent)) {
    return 'Windows 10';
  }
  if (/windows nt 6.3/i.test(userAgent)) {
    return 'Windows 8.1';
  }
  if (/windows nt 6.2/i.test(userAgent)) {
    return 'Windows 8';
  }
  if (/windows nt 6.1/i.test(userAgent)) {
    return 'Windows 7';
  }
  if (/windows nt 6.0/i.test(userAgent)) {
    return 'Windows Vista';
  }
  if (/windows nt 5.1/i.test(userAgent)) {
    return 'Windows XP';
  }
  if (/mac os x (\d+_\d+)/i.test(userAgent)) {
    return `MacOS ${RegExp.$1.replace('_', '.')}`;
  }
  if (/android (\d+\.\d+)/i.test(userAgent)) {
    return `Android ${RegExp.$1}`;
  }
  if (/cpu (?:iphone )?os (\d+_\d+)/i.test(userAgent)) {
    return `iOS ${RegExp.$1.replace('_', '.')}`;
  }
  return 'Unknown OS or Version';
}

// 获取设备类型
export function getDeviceType() {
  if (/mobile/i.test(userAgent)) {
    return 'Mobile';
  }
  if (/tablet|ipad|playbook|silk/i.test(userAgent)) {
    return 'Tablet';
  }
  if (/windows|macintosh|linux/i.test(userAgent)) {
    return 'Desktop';
  }
  return 'Unknown Device';
}

// 获取浏览器语言
export function getBrowserLanguage() {
  return navigator.language || 'Unknown Language';
}

// 获取浏览器国家
export function getBrowserCountry() {
  const language = navigator.language || 'unknown';
  const regionMatch = language.match(/-([A-Z]{2})$/); // 匹配区域代码
  return regionMatch ? regionMatch[1] : 'Unknown Country';
}

// 获取浏览器时区
export function getBrowserTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Unknown Time Zone';
}

// 获取屏幕宽度
export function getScreenWidth() {
  return screen.width;
}

// 获取屏幕高度
export function getScreenHeight() {
  return screen.height;
}

// 获取页面加载时间
export function getPageLoadTime() {
  // 获取导航性能条目
  const [navigationEntry] = window.performance.getEntriesByType('navigation');

  if (navigationEntry) {
    // 计算页面加载时间（单位：毫秒）
    return navigationEntry.loadEventEnd - navigationEntry.startTime;
  } else {
    return 'Not Support Performance Navigation Timing API';
  }
}

// 安全获取信息的工具函数
export const safeGet = (fn) => {
  try {
    return fn() + '';
  } catch (error) {
    console.warn(`Error getting info: ${error.message}`);
    return `Error getting info: ${error}`;
  }
};

export function getBaseParams() {
  return {
    // 浏览器信息
    kl: safeGet(() => navigator.userAgent),
    oi: safeGet(() => window.location.host),
    rip: safeGet(() => window.location.search.substring(1)),

    // 系统信息
    ope: safeGet(() => getOS()),
    bta: safeGet(() => getBrowserType()),
    vso: safeGet(() => getOSVersion()),
    biv: safeGet(() => getBrowserVersion()),
    tdq: safeGet(() => getDeviceType()),

    // 地区和语言信息
    lb: safeGet(() => getBrowserLanguage()),
    ch: safeGet(() => getBrowserCountry()),
    gt: safeGet(() => getBrowserTimeZone()),

    // 固定值
    cgt: 'WEB',

    // 屏幕和性能信息
    ws: safeGet(() => getScreenWidth()),
    hs: safeGet(() => getScreenHeight()),
    // plt: safeGet(() => getPageLoadTime()),
    timeStamp: safeGet(() => Date.now()),
  } || {};
}
